export const THEORIES = {
  power: {
    id: 'power',
    name: '权力分析',
    icon: '⚡',
    description: '傅柯视角 - 权力如何生产爱情、欲望、主体',
    keyConceptsShort: [
      '权力 ≠ 压制，而是生产',
      '权力生产知识、欲望、主体',
      '权力是关系性的、无处不在的',
      '反抗权力产生另一种权力'
    ],
    questions: [
      '在这一幕中，谁拥有话语权（谁能定义什么是真、什么是好）？',
      '这个权力如何通过语言、身体、空间来维持？',
      '低权力者有无微妙的反抗（沉默、延迟、曲解）？',
      '这段爱情中，是否存在"权力的反讽"（被权力者通过爱获得反控制）？',
      '如果权力关系反转，爱情的质地会改变吗？',
      '权力如何生产了这段爱情中两人的"主体"（他们变成了什么样的人）？',
      '权力如何生产了他们的欲望（他们想要什么）？',
      '权力如何生产了他们对自己和彼此的知识（他们如何理解彼此）？'
    ],
    keyInsights: [
      { title: '权力如何生产主体', description: '权力者变成了什么样的人？被权力者变成了什么样的人？这是必然吗？' },
      { title: '权力如何生产欲望', description: '他对对方的欲望是真实的吗？还是权力结构让这种欲望显得特别激烈？' },
      { title: '权力如何生产知识', description: '他们如何理解"自己"和"彼此"？这些理解是客观的，还是权力结构塑造的？' }
    ]
  },
  
  gender: {
    id: 'gender',
    name: '性别与性向分析',
    icon: '⚧️',
    description: '女性主义/酷儿理论 - 性别气质分配与性向想象',
    keyConceptsShort: [
      '性别是"做"，不是"是"',
      '性别气质是重复的表演',
      '性别是权力关系的初级场所',
      '酷儿：打破二元分类的身份与实践'
    ],
    questions: [
      '每个角色如何通过衣着、姿态、语调来"做性别"？',
      '"男性气质"和"女性气质"在这部剧中是怎样定义的？',
      '有否打破性别期待的时刻？发生了什么？',
      '这段同性关系是在强化还是挑战性别二元制？',
      '如果两人的性别气质都是"阳性"或都是"阴性"，故事会怎样？',
      '身体呈现（含蓄vs公然）如何塑造了对性向的想象？',
      '这段关系强化了刻板印象（"攻""受"的固化）吗？',
      '这段关系挑战了什么规范？'
    ],
    keyInsights: [
      { title: '性别气质分配', description: '谁被塑造为"男性化"？谁被塑造为"女性化"？这背后是什么逻辑？' },
      { title: '规范化vs颠覆性', description: '这段关系是在复制异性爱的性别权力结构，还是在挑战？' },
      { title: '身体的政治', description: '身体如何被呈现？这个选择如何塑造了对性向的想象？' }
    ]
  },
  
  modernity: {
    id: 'modernity',
    name: '现代性批判',
    icon: '⚙️',
    description: '韦伯/本雅明 - 传统失去、个人焦虑、历史意义',
    keyConceptsShort: [
      '现代性 = 个人化、理性化、失去传统确定性',
      '现代化的代价 = 传统价值瓦解、虚无感增强',
      '个人焦虑 = 必须自我选择、必须自我负责',
      '现代性的黑暗 = 进步同时也是丧失'
    ],
    questions: [
      '谁在失去什么（传统的、安全的、给定的）？谁在获得什么（自由、选择、责任）？',
      '这个交换是否值得？谁在为现代化付出代价？',
      '这部剧的主人公是"现代化的受害者"还是"现代化的获益者"？',
      '有无试图"回到过去"的人物？他的努力可能吗？值得吗？',
      '爱情在这部剧中是：现代化的出路？还是对传统的乡愁？还是两者都是？',
      '如果去掉历史背景，这部剧还是在讲"现代性"吗？',
      '这部剧是在哀悼什么？期待什么？'
    ],
    keyInsights: [
      { title: '现代性焦虑', description: '谁在经历从"身份给定"到"身份自我创造"的焦虑？' },
      { title: '现代化的代价', description: '摧毁了什么好的东西？建立了什么新的可能性？' },
      { title: '个人vs历史', description: '爱情能否抵抗历史大势？个人能改变什么？' }
    ]
  },
  
  postcolonial: {
    id: 'postcolonial',
    name: '后殖民视角',
    icon: '🌍',
    description: '萨义德/斯皮瓦克 - 自我与他者想象、代言困境',
    keyConceptsShort: [
      '东方主义 = 西方对东方的权力话语',
      '他者化 = 把某个群体变成"不同的、陌生的"',
      '代言陷阱 = 为别人说话但遮蔽真实声音',
      '文化自主性 = 既不盲目西化，也不死守传统'
    ],
    questions: [
      '这部剧强调什么（宫廷、礼仪、异国风情）？忽视什么？',
      '底层人物（如有）是被"赋权"还是被"美化"？',
      '这部剧在国际流通时，是否有被"东方主义化"消费的风险？',
      '泰国观众与国际观众对这部剧的理解会相同吗？差异在哪里？',
      '这部剧呈现了泰国的什么样的"民族自豪感"？这是问题吗？',
      '有无方式既呈现美与骄傲，又进行批判性思考？'
    ],
    keyInsights: [
      { title: '泰国的想象', description: '这部剧如何想象"泰国"？是真实的镜像还是被幻想的想象？' },
      { title: '底层人物的处境', description: '是被赋权了（获得声音和选择）还是被美化了（被浪漫化为无害的）？' },
      { title: '民族自豪感vs批判', description: '这部剧在说什么关于泰国？批评什么？赞美什么？' }
    ]
  },
  
  structure: {
    id: 'structure',
    name: '个人与结构',
    icon: '🧩',
    description: '米尔斯/萨特 - 个人选择的真实性、结构的限制',
    keyConceptsShort: [
      '社会学想象力 = 把个人问题与社会结构联系',
      '结构化 = 个人不是完全自由的主体',
      '坏信念 = 为自己的无力编造浪漫故事',
      '能动性 = 在结构中做有意识的选择'
    ],
    questions: [
      '这个"选择"有多少是被结构决定的？有多少余地是个人的？',
      '是否存在"坏信念"的时刻（为无力编造浪漫故事）？',
      '个人的反抗最后改变了结构吗？多大程度？',
      '或者，反抗本身成为了结构的一部分（被吸收、被制度化）？',
      '这部剧相信"个人改变世界"吗？还是"结构决定个人"？',
      '哪个立场更令你信服？为什么？'
    ],
    keyInsights: [
      { title: '选择的真实性', description: '每个选择都可能是结构的产物。但这不意味着没有选择自由。' },
      { title: '坏信念vs真诚', description: '什么是为无力的浪漫化？什么是真诚面对困难？' },
      { title: '改变的可能性', description: '个人能改变什么？结构会改变吗？' }
    ]
  }
};
